import { Center } from '@zorro/web/design-system';

import { SVGIconProps } from '../types';

export const PayrollIcon = ({ style }: SVGIconProps) => {
  return (
    <Center style={style}>
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_5403_28392)">
          <path d="M7 7H21V28H7V7Z" fill="#80E8B6" />
          <path
            d="M12.0003 6.6665H9.33366C8.62641 6.6665 7.94814 6.94746 7.44804 7.44755C6.94794 7.94765 6.66699 8.62593 6.66699 9.33317V25.3332C6.66699 26.0404 6.94794 26.7187 7.44804 27.2188C7.94814 27.7189 8.62641 27.9998 9.33366 27.9998H22.667C23.3742 27.9998 24.0525 27.7189 24.5526 27.2188C25.0527 26.7187 25.3337 26.0404 25.3337 25.3332V9.33317C25.3337 8.62593 25.0527 7.94765 24.5526 7.44755C24.0525 6.94746 23.3742 6.6665 22.667 6.6665H20.0003"
            stroke="#1A1721"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M12 6.66667C12 5.95942 12.281 5.28115 12.781 4.78105C13.2811 4.28095 13.9594 4 14.6667 4H17.3333C18.0406 4 18.7189 4.28095 19.219 4.78105C19.719 5.28115 20 5.95942 20 6.66667C20 7.37391 19.719 8.05219 19.219 8.55228C18.7189 9.05238 18.0406 9.33333 17.3333 9.33333H14.6667C13.9594 9.33333 13.2811 9.05238 12.781 8.55228C12.281 8.05219 12 7.37391 12 6.66667Z"
            fill="white"
            stroke="#1A1721"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M18.6663 14.6665H15.333C14.8026 14.6665 14.2939 14.8772 13.9188 15.2523C13.5437 15.6274 13.333 16.1361 13.333 16.6665C13.333 17.1969 13.5437 17.7056 13.9188 18.0807C14.2939 18.4558 14.8026 18.6665 15.333 18.6665H16.6663C17.1968 18.6665 17.7055 18.8772 18.0806 19.2523C18.4556 19.6274 18.6663 20.1361 18.6663 20.6665C18.6663 21.1969 18.4556 21.7056 18.0806 22.0807C17.7055 22.4558 17.1968 22.6665 16.6663 22.6665H13.333"
            stroke="#1A1721"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M16 22.6668V24.0002M16 13.3335V14.6668"
            stroke="#1A1721"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_5403_28392">
            <rect width="32" height="32" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </Center>
  );
};
